module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.posts) ? _c('div', [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.fields_list), function(field) {
    return [(field == 'title') ? _c('th', [_vm._v("Title")]) : _vm._e(), _vm._v(" "), (field == 'client') ? _c('th', [_vm._v("Kunde")]) : _vm._e(), _vm._v(" "), (field == 'project') ? _c('th', [_vm._v("Opgave")]) : _vm._e(), _vm._v(" "), (field == 'paydate') ? _c('th', [_vm._v("Betalingsdato")]) : _vm._e(), _vm._v(" "), (field == 'invoice_no') ? _c('th', [_vm._v("Faktura #")]) : _vm._e(), _vm._v(" "), (field == 'invoice_date') ? _c('th', [_vm._v("Fakturadato")]) : _vm._e(), _vm._v(" "), (field == 'invoiced') ? _c('th', [_vm._v("Faktureret")]) : _vm._e(), _vm._v(" "), (field == 'paid') ? _c('th', [_vm._v("Betalt")]) : _vm._e(), _vm._v(" "), (field == 'amount') ? _c('th', {
      staticClass: "align-r"
    }, [_vm._v("Kr. ex. moms")]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.posts), function(post, i) {
    return _c('tr', {
      class: _vm.negaPosi_cls(post.amount_dkk_ex_vat)
    }, [_vm._l((_vm.fields_list), function(field) {
      return [(field == 'title') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.economypostTitle(post) || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'project') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [(post.project_key) ? [_vm._v("\n                " + _vm._s(_vm.projects[post.project_key].name) + "\n              ")] : [_vm._v("\n                —\n              ")]], 2)]) : _vm._e(), _vm._v(" "), (field == 'client') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [(post.client_key) ? [_vm._v("\n                " + _vm._s(_vm.clients[post.client_key].name) + "\n              ")] : [_vm._v("\n                —\n              ")]], 2)]) : _vm._e(), _vm._v(" "), (field == 'invoice_date') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.invoice_date || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'paydatet') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.payment_due_date || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'invoice_no') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.invoice_no || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'invoiced') ? _c('td', [(post.invoiced) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : [_vm._v("—")]], 2) : _vm._e(), _vm._v(" "), (field == 'paid') ? _c('td', [(post.paid) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : [_vm._v("—")]], 2) : _vm._e(), _vm._v(" "), (field == 'amount') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("money")(post.amount_dkk_ex_vat, 0)) + "\n            ")])]) : _vm._e()]
    })], 2)
  }), _vm._v(" "), (_vm.totals) ? _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.colcount
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.totals) ? _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _c('td', {}, [_vm._v("Indtægter")]), _vm._v(" "), _c('td', {
    staticClass: "align-r posi"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.totals.income_total, 0)) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _c('td', {}, [_vm._v("Udgifter")]), _vm._v(" "), _c('td', {
    staticClass: "nega"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.totals.expense_total, 0)) + "\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.colcount
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', {
    class: _vm.negaPosi_cls(_vm.totals.total)
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.totals.total, 0)))])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {}, [_c('b', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ae5dcd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EconomyPosts.vue
// module id = 598
// module chunks = 1